var React = require('react');

function InfoOutlineGrey (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/info_outline"},React.createElement("path",{"id":"Vector","d":"M6.41602 4.08341H7.58268V5.25008H6.41602V4.08341ZM6.41602 6.41675H7.58268V9.91675H6.41602V6.41675ZM6.99935 1.16675C3.77935 1.16675 1.16602 3.78008 1.16602 7.00008C1.16602 10.2201 3.77935 12.8334 6.99935 12.8334C10.2193 12.8334 12.8327 10.2201 12.8327 7.00008C12.8327 3.78008 10.2193 1.16675 6.99935 1.16675ZM6.99935 11.6667C4.42685 11.6667 2.33268 9.57258 2.33268 7.00008C2.33268 4.42758 4.42685 2.33341 6.99935 2.33341C9.57185 2.33341 11.666 4.42758 11.666 7.00008C11.666 9.57258 9.57185 11.6667 6.99935 11.6667Z","fill":"#ABBBCC"})));
}

InfoOutlineGrey.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = InfoOutlineGrey;

InfoOutlineGrey.default = InfoOutlineGrey;
